// extracted by mini-css-extract-plugin
export var logo = "_i0-2";
export var logoWrapper = "_i0-1";
export var strip = "_i0-0";